<app-sidebar>
  <div class="platform-admin-page">
    <div class="page-header">
      <h1>Platform Admin</h1>
    </div>

    <div *ngIf="loading" class="platform-loading-state">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Loading platform admin data...</p>
    </div>

    <div class="platform-card" *ngIf="!loading">
      <div class="platform-toolbar">
        <h2>Organizations</h2>
        <button mat-raised-button color="primary" class="create-org-button" (click)="openCreateOrganizationDialog()">
          <mat-icon>add</mat-icon>
          Create Organization
        </button>
      </div>
      <div class="table-shell">
        <app-platform-organizations-table
          [organizations]="organizations"
          (edit)="editOrganization($event)"
          (billing)="openOrganizationBilling($event)"
          (delete)="deleteOrganization($event)">
        </app-platform-organizations-table>
      </div>
    </div>

    <div class="platform-card" *ngIf="!loading">
      <div class="platform-toolbar">
        <h2>Company Admins</h2>
      </div>
      <div class="table-shell">
        <app-platform-company-admins-table
          [companyAdmins]="companyAdmins"
          [loading]="loading"
          (approve)="approve($event)"
          (reject)="reject($event)"
          (viewIdDocument)="viewCompanyAdminIdDocument($event)"
          (resetPassword)="resetCompanyAdminPassword($event)"
          (resendInvite)="resendCompanyAdminInvite($event)"
          (delete)="deleteCompanyAdmin($event)">
        </app-platform-company-admins-table>
      </div>
    </div>
  </div>
</app-sidebar>
